/**
 * Theme management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class ThemeManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async exportTheme(uuid: string): Promise<Blob> {
    return this.session.request('GET', `/api/cdp/cdp_theme/extend/export/${uuid}`, {
      responseType: 'blob',
    });
  }

  async importTheme(uuid: string, file: File | Blob): Promise<Record<string, any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.session.post(`/api/cdp/cdp_theme/extend/import/${uuid}`, {
      data: formData,
      headers: {},
    });
  }
}
